import React from 'react';
import PropTypes from 'prop-types';

import UILink from '@src/components/UILink';
import { IconComment } from '@src/components/Icon';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const ProfileComment = (props) => {
	useStyles(css);
	const { children, labelLoadmore, hrefLoadmore, onClickLoadmore } = props;

	return (
		<div className={css.wrap}>
			{children && <div className={css.item}>{children}</div>}

			{(hrefLoadmore || onClickLoadmore) && (
				<UILink
					Icon={IconComment}
					label={labelLoadmore}
					href={hrefLoadmore}
					onClick={onClickLoadmore}
				/>
			)}
		</div>
	);
};

ProfileComment.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	labelLoadmore: PropTypes.string,
	hrefLoadmore: PropTypes.string,
	onClickLoadmore: PropTypes.func,
};

ProfileComment.defaultProps = {
	children: undefined,
	labelLoadmore: undefined,
	hrefLoadmore: undefined,
	onClickLoadmore: undefined,
};

export default ProfileComment;
